var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.00195C11.2044 1.00195 10.4413 1.31802 9.87868 1.88063C9.31607 2.44324 9 3.2063 9 4.00195V12.002C9 12.7976 9.31607 13.5607 9.87868 14.1233C10.4413 14.6859 11.2044 15.002 12 15.002C12.7956 15.002 13.5587 14.6859 14.1213 14.1233C14.6839 13.5607 15 12.7976 15 12.002V4.00195C15 3.2063 14.6839 2.44324 14.1213 1.88063C13.5587 1.31802 12.7956 1.00195 12 1.00195Z",
    stroke: "#4285F4",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 10.002V12.002C19 13.8585 18.2625 15.6389 16.9497 16.9517C15.637 18.2645 13.8565 19.002 12 19.002C10.1435 19.002 8.36301 18.2645 7.05025 16.9517C5.7375 15.6389 5 13.8585 5 12.002V10.002",
    stroke: "#4285F4",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 19V23.0005",
    stroke: "#4285F4",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 23H16.0003",
    stroke: "#4285F4",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMic);
export default __webpack_public_path__ + "static/media/mic.68952667bd76b4b354e6f53877c43c54.svg";
export { ForwardRef as ReactComponent };